import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import {
  PhoneVerificationTwoFaCode,
  type PhoneVerificationTwoFaCodeProps,
} from '../phone-verification-code/PhoneVerificationTwoFaCode'

type Props = PhoneVerificationTwoFaCodeProps & {
  handleCloseDialog: () => void
}

function PhoneVerificationDialog({ handleCloseDialog, ...props }: Props) {
  return (
    <Dialog open={true} onOpenChange={handleCloseDialog}>
      <DialogContent>
        <DialogTitle title="Zadanie SMS kódu" />
        <DialogDescription
          title={`Vyplňte prosím overovací kód, ktorý vám bol zaslaný na číslo ${props.verifiedPhoneNumber}.`}
        />
        <PhoneVerificationTwoFaCode {...props} />
      </DialogContent>
    </Dialog>
  )
}

export { PhoneVerificationDialog }
